import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.5 3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M8 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0m4.5 0c0-.358-.182-.727-.525-1.024A1.93 1.93 0 0 0 10.75 1.5a.75.75 0 0 1 0-1.5c.816 0 1.612.327 2.207.843C13.553 1.36 14 2.116 14 3s-.447 1.64-1.043 2.157A3.42 3.42 0 0 1 10.75 6a.75.75 0 0 1 0-1.5c.426 0 .88-.177 1.225-.476.343-.297.525-.666.525-1.024"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.5 10.25a.75.75 0 0 1 .75-.75h1.22c-.069-.93-.277-1.598-.65-2.057C7.38 6.905 6.58 6.5 5 6.5s-2.38.405-2.82.943c-.373.459-.581 1.128-.65 2.057h1.22a.75.75 0 0 1 .75.75v3c0 .69.56 1.25 1.25 1.25h.5c.69 0 1.25-.56 1.25-1.25zm1.5 3A2.75 2.75 0 0 1 5.25 16h-.5A2.75 2.75 0 0 1 2 13.25V11H.75a.75.75 0 0 1-.75-.75c0-1.42.212-2.767 1.019-3.756C1.854 5.47 3.18 5 5 5s3.146.47 3.981 1.494C9.788 7.484 10 8.831 10 10.25a.75.75 0 0 1-.75.75H8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.5 13.25v-3a.75.75 0 0 1 .75-.75h1.215c-.085-.955-.339-1.747-.783-2.323C13.152 6.492 12.27 6 10.75 6a.75.75 0 0 1 0-1.5c1.88 0 3.247.633 4.118 1.76C15.712 7.354 16 8.796 16 10.25a.75.75 0 0 1-.75.75H14v2.25A2.75 2.75 0 0 1 11.25 16h-.5a.75.75 0 0 1 0-1.5h.5c.69 0 1.25-.56 1.25-1.25"
    }, null, -1)
  ]))]))
}
export default { render: render }